import type { NameEntry } from '../employees/name-entry';
import { sortBy } from 'lodash';

export function employeesOptions(shortNamesAndMe: NameEntry[], selectedEmployees: string[] | undefined = undefined) {
  return sortBy(
    shortNamesAndMe
      .filter((item) => item.name !== '')
      .filter((item) => item.status !== 'TERMINATED' || (selectedEmployees ?? []).includes(item.uuid))
      .map((item) => ({ value: item.uuid, text: item.name })),
    ['text'],
  );
}
